import React from 'react'
import { IDocumentModel } from '../../../../interfaces/models/documents.interfaces'
import { downloadDocumentFile } from '../../../../api/documents'
import { Icon, IconChoices } from '../../../common/Icon/Icon'
import { theme } from '../../../../theme/theme'
import { cn } from '../../../../helpers/utils'

interface ChatMessageDocumentsProps {
  documents: IDocumentModel[] | undefined
  messageAuthorIsCurrentUser: boolean
}

export const ChatMessageDocuments = ({
  documents,
  messageAuthorIsCurrentUser,
}: ChatMessageDocumentsProps): JSX.Element => {
  const downloadDocument = (id: string, filename: string): void => {
    downloadDocumentFile(id, filename)
  }

  return (
    <>
      {documents && documents.length > 0 && (
        <div
          className={`-mr-1 flex max-w-xl flex-col
          ${messageAuthorIsCurrentUser ? 'self-end' : ''}
        `}
        >
          <div
            className={cn(
              'flex w-full flex-wrap gap-3',
              messageAuthorIsCurrentUser ? 'justify-end' : 'justify-start'
            )}
          >
            {documents.map((doc) => (
              <button
                key={doc._id}
                className={`flex min-w-0 flex-row items-center gap-3 whitespace-nowrap rounded mt-1
                  bg-neutral-96 py-4 px-5 hover:bg-neutral-90`}
                onClick={() => downloadDocument(doc._id, doc.filename)}
              >
                <Icon icon={IconChoices.DOCUMENT} size={24} />
                <span
                  className="overflow-hidden text-ellipsis"
                  style={theme.textVariants.baseBold}
                >
                  {doc.name}
                </span>
                <Icon icon={IconChoices.ARROW} size={24} highlighted />
              </button>
            ))}
          </div>
        </div>
      )}
    </>
  )
}
